import './polyfills';

import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import App from './App';
import registerServiceWorker from './serviceWorker/registerServiceWorker';

// Starter Actions and events
import {
  deferInstallPrompt,
  captureGlobalErrors,
  disableConsole,
  logLoadTime,
  loadLazyLoader,
  initHotjar,
  initBranch,
  initSnapchatPixelTracker,
} from './start';

import TagManager from 'react-gtm-module';

const tagManagerArgs = {
  gtmId: 'GTM-MCPMHRB',
};

TagManager.initialize(tagManagerArgs);

Sentry.init({
  dsn: 'https://7ef252f716a932a6727a6a62a77a50f1@o436025.ingest.us.sentry.io/4507502964768768',
  // integrations: [
  //   new Integrations.BrowserTracing({
  //     tracingOrigins: ['localhost', /^\//],
  //   }),
  // ],
  tracesSampleRate: 1.0,
});

deferInstallPrompt();
logLoadTime();

ReactDOM.render(
  <Sentry.ErrorBoundary>
    <App />
  </Sentry.ErrorBoundary>,
  document.getElementById('root')
);

// App Initialization actions
captureGlobalErrors();
registerServiceWorker();
disableConsole();
loadLazyLoader();
initHotjar();
// initLiveChat();
initBranch();
initSnapchatPixelTracker();



// WEBPACK FOOTER //
// ./src/index.js